var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DetailsField',{staticClass:"details-amount-currency",attrs:{"name":_vm.name}},[_c('Balance',_vm._b({attrs:{"slot":"value","balance":_vm.amount},slot:"value"},'Balance',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }